import { getAffToken, getAdminToken, clearAffToken, clearAdminToken, setNotice } from '../utils/auth';

export const base = process.env.REACT_APP_API_URL || 'http://localhost:1144/api';

//admin APIs use the admin token, everything else the affiliate token
const isAdminUrl = (url) => url.startsWith('/admin/');
const PUBLIC_URLS = ['/admin/login', '/aff/login', '/aff/register', '/aff/verifyEmail', '/aff/resendOtp', '/aff/forgotPassword', '/aff/resetPassword', '/aff/terms'];

const request = async (method, url, body) => {
  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  const isPublic = PUBLIC_URLS.includes(url);
  const token = isPublic ? null : (isAdminUrl(url) ? getAdminToken() : getAffToken());
  if (token) headers.Authorization = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(base + url, { method, headers, body: body !== undefined ? JSON.stringify(body) : undefined });
  } catch (e) {
    return { status: 'error', m: 'Could not reach the server. Please check your connection and try again.' };
  }

  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }

  //session expired / revoked: clear the token and send the user to the matching login page
  if (res.status === 401 && !isPublic) {
    if (isAdminUrl(url)) {
      clearAdminToken();
      setNotice('Your admin session has expired. Please log in again.');
      if (!window.location.pathname.startsWith('/admin/login')) window.location.assign('/admin/login');
    } else {
      clearAffToken();
      setNotice((data && data.m) || 'Your session has expired. Please log in again.');
      if (window.location.pathname !== '/login') window.location.assign('/login');
    }
    return { status: 'Unauthorized', m: (data && data.m) || 'Unauthorized' };
  }

  if (!data) return { status: 'error', m: 'Something went wrong. Please try again.' };
  //admin login answers invalid credentials with HTTP 401 + { status: 'error', m }
  return data;
};

export const GET = (url) => request('GET', url);
export const POST = (url, body) => request('POST', url, body || {});
